import React from 'react';
import { Phone, Mail, MapPin, Navigation } from 'lucide-react';
const STUDIO = {
  phone: '517-220-0621',
  email: 'info@stormtaekwondo.com',
  street: '24786 Crestview',
  cityStateZip: 'Farmington Hills, MI 48335',
  mapUrl: 'https://www.google.com/maps/dir/?api=1&destination=24786+Crestview+Farmington+Hills+MI+48335'
};
export function ContactQuickCards() {
  return <section className="py-16 bg-paper border-b border-subtle-gray" data-id="element-885">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-886">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-887">
          <a href={`tel:${STUDIO.phone}`} className="group bg-off-white border border-subtle-gray rounded-2xl p-8 flex flex-col gap-3 hover:border-storm-red transition-colors" data-id="element-888">
            <div className="w-12 h-12 bg-storm-red/10 rounded-xl flex items-center justify-center text-storm-red group-hover:bg-storm-red group-hover:text-white transition-colors" data-id="element-889">
              <Phone className="w-6 h-6" data-id="element-890" />
            </div>
            <p className="text-xs uppercase tracking-wide text-gray-warm font-bold" data-id="element-891">
              Call
            </p>
            <p className="font-display text-3xl text-ink leading-tight" data-id="element-892">
              {STUDIO.phone}
            </p>
            <span className="text-storm-red font-bold text-sm group-hover:underline" data-id="element-893">
              Tap to call →
            </span>
          </a>

          <a href={`mailto:${STUDIO.email}`} className="group bg-off-white border border-subtle-gray rounded-2xl p-8 flex flex-col gap-3 hover:border-storm-red transition-colors" data-id="element-894">
            <div className="w-12 h-12 bg-storm-red/10 rounded-xl flex items-center justify-center text-storm-red group-hover:bg-storm-red group-hover:text-white transition-colors" data-id="element-895">
              <Mail className="w-6 h-6" data-id="element-896" />
            </div>
            <p className="text-xs uppercase tracking-wide text-gray-warm font-bold" data-id="element-897">
              Email
            </p>
            <p className="text-xl font-bold text-ink break-all leading-tight" data-id="element-898">
              {STUDIO.email}
            </p>
            <span className="text-storm-red font-bold text-sm group-hover:underline" data-id="element-899">
              Send email →
            </span>
          </a>

          <a href={STUDIO.mapUrl} target="_blank" rel="noopener noreferrer" className="group bg-off-white border border-subtle-gray rounded-2xl p-8 flex flex-col gap-3 hover:border-storm-red transition-colors" data-id="element-900">
            <div className="w-12 h-12 bg-storm-red/10 rounded-xl flex items-center justify-center text-storm-red group-hover:bg-storm-red group-hover:text-white transition-colors" data-id="element-901">
              <MapPin className="w-6 h-6" data-id="element-902" />
            </div>
            <p className="text-xs uppercase tracking-wide text-gray-warm font-bold" data-id="element-903">
              Visit
            </p>
            <p className="text-base font-bold text-ink leading-snug" data-id="element-904">
              {STUDIO.street}
              <br data-id="element-905" />
              {STUDIO.cityStateZip}
            </p>
            <span className="text-storm-red font-bold text-sm group-hover:underline inline-flex items-center gap-1" data-id="element-906">
              <Navigation className="w-3.5 h-3.5" data-id="element-907" />
              Get directions →
            </span>
          </a>
        </div>
      </div>
    </section>;
}